import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';

import { Props } from '@/components/AddTask/types';
import { buttonBaseClasses, buttonColorVariants } from '@/constants/buttonStyles';
import { Color } from '@/constants/color';

const AddTask = ({ personId, taskableId, taskableType, text = 'Task' }: Props) => {
  let url = personId ? `/people/${personId}/tasks/new` : `/tasks/new`;

  if (taskableId && taskableType) {
    url += `?taskable_id=${taskableId}&taskable_type=${taskableType}&return_to=${window.location.pathname}`;
  }

  return (
    <Link
      aria-label="Add Task"
      to={url}
      className={`${buttonBaseClasses} ${
        buttonColorVariants[Color.BLUE]
      } px-2 py-1 rounded-full inline-flex items-center`}>
      <FontAwesomeIcon className="mr-1" icon={faPlus} />
      {text}
    </Link>
  );
};

export default AddTask;
